import { memo } from 'react';
import Skeleton from 'react-loading-skeleton';
import { MODIFIER_COLUMN } from '../constants/itemBranchesModifier';

const ItemBranchesModifiersTitlesSkeleton = (): JSX.Element => {
  const skeletonClassName = 'cell-skeleton';

  return (
    <div className="d-flex flex-row pr-5 item-branches-modifiers-titles item-branches-modifiers-skeleton">
      <div className={`cell cell-${MODIFIER_COLUMN.BRANCH}`}>
        <Skeleton className={skeletonClassName} />
      </div>
      <div className={`cell cell-${MODIFIER_COLUMN.OPTION_NAME}`}>
        <Skeleton className={skeletonClassName} />
      </div>
      <div className={`cell cell-${MODIFIER_COLUMN.PRICE}`}>
        <Skeleton className={skeletonClassName} />
      </div>
      <div className={`cell cell-${MODIFIER_COLUMN.DEFAULT_PRICE}`}>
        <Skeleton className={skeletonClassName} />
      </div>
      <div className={`cell cell-${MODIFIER_COLUMN.AVAILABILITY}`}>
        <Skeleton className={skeletonClassName} />
      </div>
    </div>
  );
};

export default memo(ItemBranchesModifiersTitlesSkeleton);
